import { useState } from "react";
import "./App.css";

type Status = { text: string; ok: boolean } | null;

function App() {
  const [status, setStatus] = useState<Status>(null);

  function fire(label: string, fn: () => void) {
    setStatus(null);
    setTimeout(() => {
      fn();
      setStatus({ text: `${label} sent — check snapfail incidents`, ok: true });
    }, 0);
  }

  return (
    <main>
      <header>
        <span className="badge">vite + react</span>
        <h1>snapfail demo</h1>
        <p>SDK is active. Trigger an error and watch it appear in your dashboard.</p>
      </header>

      <div className="buttons">
        <button
          onClick={() =>
            fire("TypeError", () => {
              const obj: Record<string, unknown> | null = null;
              // @ts-expect-error intentional null access
              return obj.user;
            })
          }
        >
          Trigger TypeError
          <span className="sub">null property access</span>
        </button>

        <button
          onClick={() =>
            fire("RangeError", () => {
              new Array(-1);
            })
          }
        >
          Trigger RangeError
          <span className="sub">new Array(-1)</span>
        </button>

        <button
          onClick={() => {
            Promise.reject(new Error("async task failed in vite-app"));
            setStatus({ text: "UnhandledRejection sent — check snapfail incidents", ok: true });
          }}
        >
          Trigger Rejection
          <span className="sub">unhandledrejection</span>
        </button>
      </div>

      {status && <p className={`status ${status.ok ? "ok" : "err"}`}>{status.text}</p>}

      <footer>
        <a href="https://snapfail.com" target="_blank" rel="noopener">
          snapfail.com
        </a>
      </footer>
    </main>
  );
}

export default App;
